import { api } from 'utility';
import {
  getGuildServiceUrl,
  getCreditUrl,
  getUserContactUrl,
  getCreateDeligationUrl,
  getAllBusinessInfoUrl,
  getCarTableListUrl,
  getCartableDefineDelegationUrl
} from 'URLs';
// Cards
export function checkBalance() {
  return api.get(getCreditUrl()).then((res) => res.data);
}

export function cartableDelegation(data) {
  return api.post(getCartableDefineDelegationUrl(), data).then((res) => res.data);
}
export function transfer(data) {
  return api.post(getCreateDeligationUrl(), data).then((res) => res.data);
}

/**
   * بررسی اینکه این حساب کارتابل هست یا خیر؟
   */
export function getCarTableList( data = {}) {
  return api.post(getCarTableListUrl(), data).then((res) => res.data);
}
export function checkContact(data) {
  return api.post(getUserContactUrl(), data).then((res) => res.data);
}

export function getBusinessList(obj) {
  const params = { offset: 0, size: 10, ...obj };
  return api.get(getAllBusinessInfoUrl(), { params }).then((res) => res.data);
}

export function getGuildsList(obj) {
  const params = { ...obj };
  return api.get(getGuildServiceUrl(), { params }).then((res) => res.data);
}

export default {
  checkContact,
  checkBalance,
  transfer,
  getBusinessList,
  getGuildsList,
  getCarTableList,
  cartableDelegation
};
